import { render } from "./CreateCellButton.vue?vue&type=template&id=488c1b64"
import script from "./CreateCellButton.vue?vue&type=script&lang=js"
export * from "./CreateCellButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__